<template>
  <div class="flex flex-col items-start" :class="fieldWidth ? `field-${fieldWidth}` : 'w-full'">
    <label
      v-if="label"
      :for="id ? id : `${label}-field`"
      v-text="label"
      :class="labelSize ? `input--label--${labelSize}` : 'input--label'"
    />
    <input
      :type="type"
      :placeholder="placeholder"
      :id="id || `${label}-field`"
      spellcheck="false"
      v-model="val"
      @input="$emit('input', $event)"
      @blur="$emit('blur')"
      @focus="$emit('focus', $event)"
      :class="[inputTextSize ? `input--text--${inputTextSize}` : 'input--text', 'w-full']"
      :required="required"
      :pattern="pattern"
      :title="title"
    />
    <small v-if="type === 'tel'" class="mt-1">Format: 123-456-7890</small>

    <ul class="input--errors">
      <li
        v-for="(error, index) in errors"
        :key="index"
        v-text="error.message"
        class="input--error"
      />
    </ul>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'InputField',
  props: {
    label: {
      type: String,
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: 'Placeholder...',
    },
    value: {
      type: [String, Number, Boolean],
      required: true,
    },
    errors: {
      type: Array,
      required: true,
    },
    id: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    pattern: {
      type: String,
    },
    title: {
      type: String,
    },
    labelSize: {
      type: String,
    },
    inputTextSize: {
      type: String,
    },
    fieldWidth: {
      type: String,
      default: '',
    },
  },
  emits: ['blur', 'focus', 'input', 'update:value'],
  setup(props, context) {
    const val = computed({
      get: () => props.value,
      set: (value) => context.emit('update:value', value),
    })

    return { val }
  },
}
</script>
